import { render, staticRenderFns } from "./DataViewSidebarSecurityQuestions.vue?vue&type=template&id=f352521c&scoped=true&"
import script from "./DataViewSidebarSecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarSecurityQuestions.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarSecurityQuestions.vue?vue&type=style&index=0&id=f352521c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f352521c",
  null
  
)

export default component.exports